import type {HomeFeatureTile} from '@vio/core/src/brand/capabilities/types/domains'

const sharedTileImagesPath = 'HomePage/rebrand'

const tileImageFiles: Record<HomeFeatureTile, string> = {
  dealFreeze: 'deal-freeze.webp',
  combineRooms: 'split-booking-mobile.webp',
  payLater: 'pay-later.webp',
  priceAlerts: 'price-track.webp',
  priceCalendar: 'price-calendar.webp'
}

export const getTileImageUrl = (
  imagesPath: string | null,
  languageCode: string,
  tile: HomeFeatureTile
) =>
  `${process.env.NEXT_PUBLIC_STATIC_ASSETS_ENDPOINT}${imagesPath ?? sharedTileImagesPath}/${languageCode}/${tileImageFiles[tile]}?v=2`
